import React from "react";
import {
  View,
  StyleSheet,
  Alert,
  Platform,
  TouchableOpacity,
  SafeAreaView,
} from "react-native";
import { Picker } from "@react-native-picker/picker";
import { useAppContext } from "../context/AppContext";
import { useLikedNames } from "../context/LikedNamesContext";
import { useTranslation } from "../hooks/useTranslation";
import CustomText from "../components/CustomText";

const countryData = [
  { label: "🇺🇸  United States", value: "eeuu" },
  { label: "🇸🇪  Sweden", value: "sweden" },
  { label: "🇪🇸  Spain", value: "spain" },
  { label: "🇮🇹  Italy", value: "italy" },
  { label: "🇬🇧  UK", value: "uk" },
];

const languageData = [
  { label: "🇬🇧 English", value: "en" },
  { label: "🇪🇸 Spanish", value: "es" },
  { label: "🇸🇪 Swedish", value: "sv" },
];

const SettingsScreen = () => {
  const {
    nameOriginCountry = "spain",
    setNameOriginCountry,
    language,
    setLanguage,
  } = useAppContext();
  const { clearLikedNames } = useLikedNames();
  const { getTranslation } = useTranslation();

  const handleResetData = () => {
    Alert.alert(
      getTranslation("ID_RESET_ALL_DATA"),
      getTranslation("ID_RESET_ALL_DATA_CONFIRM"),
      [
        { text: getTranslation("ID_CANCEL"), style: "cancel" },
        {
          text: getTranslation("ID_RESET"),
          style: "destructive",
          onPress: clearLikedNames,
        },
      ]
    );
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.container}>
        <View style={styles.section}>
          <CustomText style={styles.title}>
            {getTranslation("ID_NAME_ORIGIN_COUNTRY")}
          </CustomText>
          <View style={styles.pickerContainer}>
            <Picker
              selectedValue={nameOriginCountry}
              onValueChange={setNameOriginCountry}
              style={styles.picker}
              itemStyle={{ color: "black" }}
            >
              {countryData.map((country) => (
                <Picker.Item
                  key={country.value}
                  label={country.label}
                  value={country.value}
                />
              ))}
            </Picker>
          </View>
        </View>

        <View style={styles.section}>
          <CustomText style={styles.title}>
            {getTranslation("ID_SELECT_LANGUAGE")}
          </CustomText>
          <View style={styles.pickerContainer}>
            <Picker
              selectedValue={language}
              onValueChange={setLanguage}
              style={styles.picker}
              itemStyle={{ color: "black" }}
            >
              {languageData.map((language) => (
                <Picker.Item
                  key={language.value}
                  label={language.label}
                  value={language.value}
                />
              ))}
            </Picker>
          </View>
        </View>

        <View style={styles.section}>
          <CustomText style={styles.title}>
            {getTranslation("ID_RESET_DATA")}
          </CustomText>
          <View style={styles.resetRow}>
            <CustomText style={styles.description}>
              {getTranslation("ID_RESET_ALL_DATA_DESCRIPTION")}
            </CustomText>
            <TouchableOpacity
              style={styles.dangerButton}
              onPress={handleResetData}
            >
              <CustomText style={styles.dangerButtonText}>
                {getTranslation("ID_RESET")}
              </CustomText>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "#F9FAFB", // Color de fondo que coincide con el diseño de la app
  },
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: "#fff",
  },
  section: {
    marginBottom: 30,
    padding: 10,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 10,
    backgroundColor: "#f9f9f9",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 10,
  },
  pickerContainer: {
    marginBottom: 20,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 10,
    overflow: "hidden",
    height: Platform.OS === "ios" ? 150 : 50,
    justifyContent: "center",
    alignItems: "center",
  },
  picker: {
    width: "100%",
    height: "100%",
  },
  resetRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
  },
  description: {
    flex: 1,
    fontSize: 16,
    color: "#333",
    marginRight: 10,
  },
  dangerButton: {
    backgroundColor: "#FF3B30",
    padding: 10,
    borderRadius: 5,
  },
  dangerButtonText: {
    color: "#fff",
    fontWeight: "bold",
  },
});

export default SettingsScreen;
